import { Space, theme, Typography } from "antd";
import { AutoCenter, Button } from "antd-mobile";
import { FC } from "react";
import { styled } from "styled-components";
import CenterContent from "../layouts/CenterContent";

const { Title } = Typography;

interface IProps {
  onRefresh(): void;
}

const AppConflictScreen: FC<IProps> = ({ onRefresh }) => {
  const { token } = theme.useToken();

  return (
    <CenterContent $backgroundColor={token.colorWarning} $color={token.colorText} $padding={token.padding}>
      <Space direction="vertical" align="center" size="middle">
        <AutoCenter style={{ textAlign: "center" }}>
          <Title level={2}>App Conflict</Title>
        </AutoCenter>
        <AutoCenter style={{ textAlign: "center" }}>
          <Title level={4}>To continue on mobile, please sign out from the desktop version first</Title>
        </AutoCenter>
        <StyledImage src="/img/app-conflict.png" alt="" />
        <Button onClick={onRefresh}>Refresh</Button>
      </Space>
    </CenterContent>
  );
};

export default AppConflictScreen;

const StyledImage = styled.img`
  width: 256px;
  height: 256px;
`;
